exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress[data-v-80e6121c]{border-radius:.125rem}", ""]);

// exports
